import api from ".";
import cookiesModifier from "../utils/cookies";

import { ISaveProgram } from "../types/program";

export const createProgram = async (data: ISaveProgram) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`programs`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateProgram = async (data: ISaveProgram) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`programs/${data.id}`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteProgram = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`programs/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const duplicateProgram = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`programs/duplicate/${id}`);
        return res.data;
    } catch (error) {
        throw error;
    }
}